exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge[data-v-6658ca23] { \n    position: relative;\n    top: -15px;\n    left: 7px;\n    display: inline-block;\n    font-size: 0.75em;\n}\n.small[data-v-6658ca23] { \n    font-size: 1.2em;\n}\n", ""]);

// exports
